import { useContext } from 'react';
import {
  NotificationCountContext,
  type NotificationCountContextValue,
} from '../context/notificationCountContext';

export function useNotificationCount(): NotificationCountContextValue {
  const context = useContext(NotificationCountContext);
  if (context === null) {
    throw new Error('useNotificationCount must be used within NotificationCountProvider');
  }

  return context;
}
